import React, { useContext, useEffect } from "react";
import mixpanel from "mixpanel-browser";
import { AnalyticsContext, AppContext } from "./Context";

mixpanel.init("8726ad526e96df9f0b32d3a02875684f", {
  debug: false,
  track_pageview: false,
  ip: false,
  persistence: "localStorage",
});

function AnalyticsWrapper({ children }) {
  const { analyticsEnv, forgeContext } = useContext(AppContext);

  useEffect(() => {
    if (!analyticsEnv !== "production") return;
    const { cloudId } = forgeContext;
    if (!cloudId) return;

    mixpanel.identify(cloudId);
    mixpanel.people.set({ $cloudId: `${cloudId}` });
  }, [forgeContext, analyticsEnv]);

  const logEvent = (name, config) => {
    if (analyticsEnv === "production") {
      mixpanel.track(name, { ...(config || {}) });
    }
  };

  return (
    <AnalyticsContext.Provider value={{ logEvent }}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export default AnalyticsWrapper;
